import { ApiFactory } from './api-factory'

export class AppPublicApiFactory extends ApiFactory {
  get _baseUrl() {
    return this._config.API_APP
  }
}
